import { render, staticRenderFns } from "./TurnosPostventa.vue?vue&type=template&id=1bfd37d4"
import script from "./TurnosPostventa.vue?vue&type=script&lang=js"
export * from "./TurnosPostventa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports